import React from 'react';
import { Button, Form } from 'antd';
import styles from './index.module.scss';
import LoginAgreementItem from 'component/AuthForm/LoginAgreementItem';
import LoginMobileCaptchaItem from 'component/AuthForm/LoginMobileCaptchaItem';
import LoginMobileItem from 'component/AuthForm/LoginMobileItem';
import { CodeLogin } from 'lib/publicUsecase/CodeLogin';
import { Pivot } from 'api';
import { getSessionId } from 'util/session';
import MobileCaptcha from 'lib/publicUsecase/MobileCaptcha';
import { getMobile } from 'data/storage';
import { useStore } from '../useStore';
import useCountDown from 'util/countdown';
import { useDispatch } from 'react-redux';
import { afterLogin } from 'model/login';

interface FormData {
  mobile: string;
  mobileCaptcha: string;
  agreement: boolean;
}

const BaseLoginWithCode: React.FC = () => {
  const [form] = Form.useForm<FormData>();
  const { countDown, isDisposed, startCountDown } = useCountDown();
  const { formStore, stateStore, stateData, formData, handleFromDataChange } = useStore<FormData>(
    { mobile: getMobile(), agreement: false, mobileCaptcha: '' },
    {
      loginLoading: false,
      mobileCaptchaeLoading: false,
      mobileCaptchaeError: ''
    }
  );
  const dispatch = useDispatch();
  const codeLogin = new CodeLogin({
    API: {
      getSessionId,
      loginByCode: (mobile: string, mobileCaptcha: string, sessionId: string) => Pivot.loginByMobile(mobileCaptcha, mobile, sessionId).toPromise()
    },
    stateStore,
    formStore
  });
  const mobileCaptchaInstance = new MobileCaptcha({
    API: {
      startCountDown,
      getMobileCaptcha: (mobile, type, slidingCaptcha) => Pivot.getMobileCaptchas(mobile, type, slidingCaptcha).toPromise()
    },
    state: stateStore
  });

  const onFieldsChange = () => {
    handleFromDataChange(form.getFieldsValue());
  };

  const onFinish = async () => {
    const res = await form.validateFields();
    if (!res) return;
    const data = await codeLogin.loginByCode();
    if (!data) return;
    // 登录成功后跳转
    console.log('登录成功后跳转', data);
    dispatch(
      afterLogin({
        mobile: formData.mobile,
        token: data.access_token,
        userId: data.userId
      })
    );
  };

  const onClickVerifyCode = async (slidingCaptcha: any) => {
    const mobile = form.getFieldValue('mobile');
    await mobileCaptchaInstance.getMobileCaptcha(mobile, 5, slidingCaptcha);
  };

  return (
    <div className={styles.main}>
      <div className={styles.mainTitleContainer}>
        <div className={styles.mainTitle}>账号登录</div>
        <div className={styles.mainDesc}>若未注册，登录后自动注册</div>
      </div>
      <div className={styles.formWrapper}>
        <Form form={form} onFieldsChange={onFieldsChange} onFinish={onFinish} validateTrigger="onBlur" size="large" initialValues={formStore.value}>
          <LoginMobileItem name="mobile" />
          <LoginMobileCaptchaItem
            countDown={countDown}
            isDisposed={isDisposed}
            name="mobileCaptcha"
            help={stateData.mobileCaptchaeError}
            loading={stateData.mobileCaptchaeLoading}
            disabled={!formData.mobile}
            form={form}
            targetValication={'mobile'}
            onClick={onClickVerifyCode}
          />
          <Button loading={stateData.loginLoading} disabled={!formData.mobile || !formData.mobileCaptcha} type="primary" block size="large" htmlType="submit">
            登录
          </Button>
          <LoginAgreementItem name="remember" />
        </Form>
      </div>
    </div>
  );
};

export default BaseLoginWithCode;
